import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { Trans, useTranslation } from "react-i18next";
import { Page } from "@/components";
import { UthevdTekst } from "@/components/UthevdTekst";
import { SelskapForm } from "./SelskapForm";

export const SelskapPage = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <section className="max-w-card flex flex-col gap-6">
        <Heading level={1} data-size={"lg"}>
          {t("pages.velg-selskap.tittel")}
        </Heading>
        <Paragraph>
          <Trans
            i18nKey="pages.velg-selskap.beskrivelse"
            components={{
              Uthevd: <UthevdTekst />,
            }}
          />
        </Paragraph>

        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={t("eksterneLenker.altinn-roller.url")}
        >
          {t("eksterneLenker.altinn-roller.label")}
          <ExternalLinkIcon fontSize={"1.5rem"} className="pl-1" />
        </Link>
        <Card variant="tinted" className="bg-balder-background-tinted">
          <SelskapForm />
        </Card>
      </section>
    </Page>
  );
};
